import { render, staticRenderFns } from "./TeamReports.vue?vue&type=template&id=148b5290&scoped=true"
import script from "./TeamReports.vue?vue&type=script&lang=ts"
export * from "./TeamReports.vue?vue&type=script&lang=ts"
import style0 from "./TeamReports.vue?vue&type=style&index=0&id=148b5290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b5290",
  null
  
)

export default component.exports